import { createFileRoute } from '@tanstack/react-router';
import { CreateCommunicationPage } from '~/pages/admin/create-communication-page';

export const Route = createFileRoute('/admin/communications/new')({
  component: CreateCommunicationPage,
});

